/** One scoped palette for standalone Cash, embedded modules and native dialogs. */
export const cashColorStyles = `
.cash-module,.cash-dialog,.app-root[data-cash-app],.app-profile,.app-update-lock{
  --cash-brand:var(--brand,var(--brand-primary-base,#5f162a));
  --cash-on-brand:#ffffff;
  --cash-brand-soft:#fbf3f5;
  --cash-brand-line:#dab5c1;
  --cash-brand-hover:#f2e8ec;
  --cash-focus:#a86178;
  --cash-bg:#f7f7f9;
  --cash-surface:#ffffff;
  --cash-subtle:#f1f1f5;
  --cash-text:#22232c;
  --cash-muted:#626371;
  --cash-line:#e2e3e9;
  --cash-control-line:#7b7d8b;
  --cash-success:#215d38;
  --cash-success-bg:#eaf7ee;
  --cash-success-line:#cfe6d7;
  --cash-warning:#86550e;
  --cash-warning-bg:#fff5df;
  --cash-warning-line:#ebddbd;
  --cash-danger:#a72028;
  --cash-danger-bg:#fff0f0;
  --cash-danger-line:#eac5c9;
  --cash-info:#385176;
  --cash-info-bg:#eef4fc;
  --cash-info-line:#dce5f0;
  --cash-shadow:rgba(21,19,43,.16);
  --cash-shadow-soft:rgba(32,32,43,.04);
  --cash-backdrop:rgba(24,24,36,.4);
  --cash-update-overlay:rgba(255,255,255,.93);
  --cash-symbol-overlay:rgba(255,255,255,.14);
  color-scheme:light;
}
`;
